import React from 'react'

const Tagline = ({ heading = "Wellness Pathways: Empowering Your Journey to Health and Vitality", paragrpah = "Health Arc was established in 2020 with sole purpose of providing quality therapy services for your convenience." }) => {
    return (
        <div className="flex items-center flex-col gap-[24px] px-[4vw] py-[64px]">
            <span className="text-center text-[36px] font-[600] text-[#101828] max-w-[780px]">
                {heading}
            </span>
            <span className="text-center text-[20px] text-[#475467] max-w-[780px]">
                {paragrpah}
            </span>
        </div>
    )
}

export default Tagline